import { TypedAudioNode } from "./_Base";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { AudioBuilder } from "../../../core/audio/AudioBuilder";
export const ENVELOPE_DEFAULTS = {
  attackCurve: "linear",
  attack: 0.01,
  decayCurve: "exponential",
  decay: 0.1,
  releaseCurve: "exponential",
  release: 1,
  sustain: 0.5
};
class EnvelopeAudioParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.attack = ParamConfig.FLOAT(ENVELOPE_DEFAULTS.attack, {
      range: [0, 0.1],
      rangeLocked: [true, false]
    });
    this.decay = ParamConfig.FLOAT(ENVELOPE_DEFAULTS.decay, {
      range: [0, 1],
      rangeLocked: [true, false]
    });
    this.sustain = ParamConfig.FLOAT(ENVELOPE_DEFAULTS.sustain, {
      range: [0, 1],
      rangeLocked: [true, false]
    });
    this.release = ParamConfig.FLOAT(ENVELOPE_DEFAULTS.release, {
      range: [0, 1],
      rangeLocked: [true, false]
    });
  }
}
const ParamsConfig = new EnvelopeAudioParamsConfig();
export class EnvelopeAudioNode extends TypedAudioNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "envelope";
  }
  initializeNode() {
    this.io.inputs.setCount(0);
  }
  cook(inputContents) {
    const audioBuilder = new AudioBuilder();
    audioBuilder.setEnvelopeParams({
      attackCurve: "linear",
      attack: this.pv.attack,
      decayCurve: "exponential",
      decay: this.pv.decay,
      releaseCurve: "exponential",
      release: this.pv.release,
      sustain: this.pv.sustain
    });
    this.setAudioBuilder(audioBuilder);
  }
}
